import type { PartnerMaterialAdmin } from '@bliks-io/contracts';

/**
 * Swaps a material with its neighbour inside the same category and returns
 * the position updates for every material whose place changed. Partners see
 * the list grouped by category, so order only matters within one.
 */
export function reorderWithinCategory(
  materials: PartnerMaterialAdmin[],
  id: string,
  direction: -1 | 1
): { id: string; position: number }[] {
  const order = [...materials].sort((a, b) => a.position - b.position);
  const from = order.findIndex((material) => material._id === id);
  if (from < 0) return [];
  const category = order[from].category;
  const siblings = order
    .map((material, index) => ({ material, index }))
    .filter(({ material }) => material.category === category);
  const at = siblings.findIndex(({ index }) => index === from);
  const neighbour = siblings[at + direction];
  if (!neighbour) return [];

  [order[from], order[neighbour.index]] = [order[neighbour.index], order[from]];
  return order.flatMap((material, position) =>
    material.position === position ? [] : [{ id: material._id, position }]
  );
}
